import { Component, ElementRef, EventEmitter, input, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Settlement } from 'src/app/models/settlement.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-tenant',
  template: `
    <ng-template #modalTenant let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Inquilino x</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <app-form-tenant
          [tenant]="tenant"
          (saveTenant)="createTenant($event)"
        ></app-form-tenant>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalTenantComponent {
  @Input() unit: any;
  @Input() building: any;
  settlement = input.required<Settlement>();
  @Input() profile: any;
  @Input() permissions: any;
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalTenant') modalTenant !: ElementRef;
  private modalRef: NgbModalRef | undefined;

  tenant: any;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private modalService: NgbModal
  ) { }

  updateTenant(event: any) {
    console.log('updateTenant', event);
    // this.updateDismiss.emit(event);
  }

  createTenant(data: any) {
    const payload: any = {
      avatar: data.avatar,
      name: data.name,
      last_name: data.last_name,
      email: data.email,
      phone: data.phone,
      unit_id: this.unit.id,
    }

    this.store.createTenant(payload).subscribe({
      next: (data: any) => {
        this.toastr.success('Inquilino se creó correctamente.', 'Éxito');

        let address: any = {
          tenant_id: data.id,
          country: this.settlement().country,
          city: this.settlement().city,
          state: this.settlement().state,
          address: this.settlement().address,
          zip_code: this.settlement().zip,
        };

        this.store.createTenantAddress(address).subscribe((address: any) => {
          console.log('address => ', address);
        });

        
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(`Inquilino no pudo ser creado. \n ${err.error.exception}`, 'Error');
      },
      complete: () => this.dismiss()
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
